import { AssignmentPagination, AssignmentPaginationParameters } from "@carnegie-learning/data-access-angular-passport";
import { createAction, props } from "@ngrx/store";
import { PPAssignment as Assignment } from "cli-types";

// ------ Load students for a student in Course ------
export const loadCourseAssignmentsStudents = createAction(
    "[Course Assignment Students] Load Course Assignment Students",
    props<{
        payload: AssignmentPaginationParameters;
    }>()
);
export const loadCourseAssignmentsStudentsFail = createAction(
    "[Course Assignment Students] Load Course Assignment Students Fail",
    props<{
        payload: any;
    }>()
); // if failure, we need constructor to send a message as the payload property back from the server
export const loadCourseAssignmentsStudentsSuccess = createAction(
    "[Course Assignment Students] Load Course Assignment Students Success",
    props<{
        payload: AssignmentPagination;
    }>()
);

// ------ Delete student ------
export const deleteCourseAssignmentsStudent = createAction(
    "[Course Assignments Student] Delete Assignment",
    props<{
        payload: Assignment;
    }>()
);
export const deleteCourseAssignmentsStudentFail = createAction(
    "[Course Assignment Student] Delete Assignment Fail",
    props<{
        payload: any;
    }>()
); // if failure, we need constructor to send a message as the payload property back from the server
export const deleteCourseAssignmentsStudentSuccess = createAction(
    "[Course Assignment Student] Delete Assignment Success",
    props<{
        assignmentID: number;
    }>()
);


export const setCourseAssignmentsStudentPaginationParams = createAction(
    "[Course Assignment Student] Set Student Pagination Params",
    props<{
        payload: any;
    }>()
);


// ------ Reset Assignment Overview Page Store ------
export const resetAssignmentOverviewPageStore = createAction(
    "[Assignment] Reset Assignment Overview Page Store"
);
